var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "auto",
    viewBox: "0 0 420 420",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-56.3006,-46.2059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05864,0,0,1.05864,-15.6035,-15.0115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.095,57.827C375.47,57.827 464.268,146.625 464.268,256C464.268,365.375 375.47,454.173 266.095,454.173C156.72,454.173 67.921,365.375 67.921,256C67.921,146.625 156.72,57.827 266.095,57.827ZM266.095,68.558C162.643,68.558 78.653,152.548 78.653,256C78.653,359.452 162.643,443.442 266.095,443.442C369.547,443.442 453.536,359.452 453.536,256C453.536,152.548 369.547,68.558 266.095,68.558Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.615559,0,0,0.615559,117.392,94.2004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.575,77.473L303.843,29.019L427.661,161.251L256,203.74L270.496,150.802C261.04,148.431 251.326,147.231 241.573,147.231C175.951,147.231 122.674,200.507 122.674,266.129C122.674,331.752 175.951,385.028 241.573,385.028C307.239,385.028 360.472,331.795 360.472,266.129L436.489,266.129C436.489,373.779 349.222,461.046 241.573,461.046C133.996,461.046 46.657,373.707 46.657,266.129C46.657,158.552 133.996,71.213 241.573,71.213C258.108,71.213 274.575,73.317 290.575,77.473Z",
    style: {
      fill: "white"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.2c5faea32721d55a1235d259abaec52c.svg";
export { ForwardRef as ReactComponent };